module.exports = __webpack_public_path__ + "img/instagram.217f065e.svg";